import { CSVLink } from 'react-csv';
import moment from 'moment';
import { CLIENTS_TYPES } from '../../../constants';
import { classNames } from '../../../shared/utility';
import dayjs from 'dayjs';
import { isValueCorrect } from '../../../shared/userFunctions';

const ExportToCSV = ({ data = [], type = 'classPassesReport', gymName = '', disabled = false, fullWidth = false }) => {
  let csvData = [];
  const defaultClassStyles = classNames(
    'block bg-primary text-white font-bold uppercase text-center py-[10px] px-[25px] my-auto hover:text-white hover:no-underline w-full whitespace-nowrap',
    fullWidth ? '' : ' md:w-auto'
  );

  if (disabled) {
    return <div className={[defaultClassStyles, 'cursor-not-allowed'].join(' ')}>Export to CSV</div>;
  }

  switch (type) {
    case 'classPassesReport': {
      csvData = data.map((elem) => {
        return {
          gym: gymName,
          name: elem.user.name,
          last_name: elem.user.last_name,
          classPassesOverall: elem.total
        };
      });
      break;
    }
    case 'recordedAttendancesReport': {
      csvData = data.map((elem) => {
        return {
          gym: gymName,
          name: elem.userId.name,
          last_name: elem.userId.last_name,
          createdDate: moment(elem.createdDate).format('YYYY-MM-DD')
        };
      });
      break;
    }
    case 'clientsDetailReport': {
      csvData = data.map((elem) => {
        const products = elem.products;
        return {
          gym: gymName,
          name: elem.name,
          last_name: elem.last_name,
          email: elem.email,
          address_line1: elem.address_line1,
          account_type: elem.customerType === CLIENTS_TYPES.FULL_MEMBER ? 'Membership' : 'Class Pass',
          registrationDate: isValueCorrect(elem.registrationDate)
            ? dayjs(elem.registrationDate).format('YYYY-MM-DD')
            : 'N/A',
          membership_status: elem.customerType === CLIENTS_TYPES.FULL_MEMBER ? elem.status : 'N/A',
          marketing: elem.marketing === 'true' ? 'Y' : 'N',
          planName: elem.currentMembershipPlan ? elem.currentMembershipPlan.planName : 'N/A',
          current_period_end: elem.currentMembershipPlan
            ? moment(elem.currentMembershipPlan.current_period_end).format('YYYY-MM-DD')
            : 'N/A',
          is_product_purchased: products.length > 0 ? 'true' : 'false',
          last_purchased_product:
            elem.customerType === CLIENTS_TYPES.CLASS_PASS_MEMBER && products.length > 0
              ? products[0] && products[0].productId
                ? products[0].productId.name
                : 'Product no longer exists'
              : 'N/A',
          last_purchased_product_type:
            elem.customerType === CLIENTS_TYPES.CLASS_PASS_MEMBER && products.length > 0
              ? products[0].productType
              : 'N/A',
          are_terms_conditions_accepted: !elem.areTermsAndConditionsAccepted
            ? 'N/A'
            : elem.areTermsAndConditionsAccepted === true
              ? 'Y'
              : 'N'
        };
      });
      break;
    }
    case 'classAttendanceReport': {
      csvData = data.map((elem) => {
        return {
          gymName: elem.gymName,
          gymId: elem.gymId,
          classId: elem.id,
          name: elem.eventName,
          type: elem.eventType,
          trainer: elem.hostName,
          date: moment(elem.date).format('YYYY-MM-DD'),
          time: elem.time,
          capacity: elem.capacity,
          attendanceStatus_ACTIVE: elem.attendances && elem.attendances.active ? elem.attendances.active.count : 0,
          attendanceStatus_ABSENT: elem.attendances && elem.attendances.absent ? elem.attendances.absent.count : 0,
          attendanceStatus_ATTENDED:
            elem.attendances && elem.attendances.attended ? elem.attendances.attended.count : 0,
          attendanceStatus_CANCELLED:
            elem.attendances && elem.attendances.cancelled ? elem.attendances.cancelled.count : 0,
          attendanceStatus_LATE_CANCELLATION:
            elem.attendances && elem.attendances['late-cancellation'] ? elem.attendances['late-cancellation'].count : 0,
          attendanceStatus_PENDING: elem.attendances && elem.attendances.pending ? elem.attendances.pending.count : 0,
          duration: elem.duration ? elem.duration : '',
          waitingList_COUNT: elem.waitList && elem.waitList.count ? elem.waitList.count : 0
        };
      });
      break;
    }
    case 'classAttendanceNameReport': {
      data.forEach((classDetail) => {
        if (classDetail.attendances) {
          for (let status in classDetail.attendances) {
            if (classDetail.attendances[status].attendeesDetail) {
              const attendeesDetail = classDetail.attendances[status].attendeesDetail;
              for (let index = 0; index < attendeesDetail.length; index++) {
                csvData.push({
                  gymName: classDetail.gymName,
                  gymId: classDetail.gymId,
                  classId: classDetail.id,
                  name: classDetail.eventName,
                  type: classDetail.eventType,
                  trainer: classDetail.hostName,
                  date: moment(classDetail.date).format('YYYY-MM-DD'),
                  time: classDetail.time,
                  capacity: classDetail.capacity,
                  userId: attendeesDetail[index].id,
                  user: `${attendeesDetail[index].name} ${attendeesDetail[index].lastName}`,
                  status,
                  duration: classDetail.duration ? classDetail.duration : '',
                  waitingList_COUNT: classDetail.waitList && classDetail.waitList.count ? classDetail.waitList.count : 0
                });
              }
            }
          }
        } else {
          let csvRow = {
            gymName: classDetail.gymName,
            gymId: classDetail.gymId,
            classId: classDetail.id,
            name: classDetail.eventName,
            type: classDetail.eventType,
            trainer: classDetail.hostName,
            date: moment(classDetail.date).format('YYYY-MM-DD'),
            time: classDetail.time,
            capacity: classDetail.capacity,
            duration: classDetail.duration ? classDetail.duration : '',
            waitingList_COUNT: classDetail.waitList && classDetail.waitList.count ? classDetail.waitList.count : 0
          };
          csvData.push(csvRow);
        }
      });
      break;
    }
    case 'classDetail': {
      csvData = data.attendanceList.map((attendance) => {
        return {
          gym: gymName,
          id: data._id,
          name: data.name,
          date: moment(data.classDate).format('YYYY-MM-DD'),
          time: data.classTime,
          trainer: data.trainer ? `${data.trainer.name} ${data.trainer.last_name}` : ' ',
          user: `${attendance.user.name} ${attendance.user.last_name}`,
          status: attendance.status
        };
      });
      break;
    }
    case 'debtorsReportsPayg': {
      csvData = data.map((element) => {
        return {
          gym: element.gymName,
          name: element.name,
          lastName: element.lastName,
          type: element.userType,
          createdDate: moment(element.createdDate).format('YYYY-MM-DD'),
          classDate: moment(element.classDate).format('YYYY-MM-DD'),
          amount: element.cost
        };
      });
      break;
    }
    case 'debtorsReportsMembership': {
      csvData = data.map((element) => {
        return {
          gym: element.gymName,
          name: element.name,
          lastName: element.lastName,
          type: element.userType,
          dateFailedOn: moment(element.dateFailedOn).format('YYYY-MM-DD'),
          planName: element.planName,
          expiryDate: moment(element.currentPeriodEnd).format('YYYY-MM-DD'),
          amount: element.cost
        };
      });
      break;
    }
    case 'payrollReport': {
      data.map((element) => {
        csvData.push({
          classId: element._id,
          className: element.name,
          classDate: moment(element.classDate).format('YYYY-MM-DD'),
          classType: element.classType,
          classTime: element.classTime,
          gymId: element.gymId,
          gymName: element.gymName,
          trainerId: element.trainer._id,
          trainerName: element.trainer.name + ' ' + element.trainer.last_name
        });
      });
      break;
    }
    default:
      return (csvData = [{ info: 'wrong data' }]);
  }

  return (
    <CSVLink
      data={csvData}
      className={defaultClassStyles}
      filename={`${gymName}_${type}_${moment().format('DD/MM/YYYY')}.csv`}>
      Export to CSV
    </CSVLink>
  );
};

export default ExportToCSV;
